import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { onError } from "../libs/errorLib";

import { API } from "aws-amplify";
import "./VisitorBook.css";

import Papa from "papaparse";

//import LoaderButton2 from "../components/LoaderButton2";
//import LoaderButton3 from "../components/LoaderButton3";

//import { Modal, CircularProgress } from "@mui/material";


import LoaderButtonX from "../components/LoaderButtonX";
//import "./FineTuner.css";
import RuleInput from "../components/RuleInput"
import LoadingModal from "../components/LoadingModal"
import JSZip from "jszip";
import { saveAs } from "file-saver"; // optional helper for downloads
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import { BsArrowRepeat } from "react-icons/bs";


import Table from "react-bootstrap/Table";

import { makeStyles, withStyles, styled } from '@material-ui/core/styles';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import QueueIcon from '@material-ui/icons/Queue';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Button from '@material-ui/core/Button';
//import Button from "../components/LoaderButtonX";
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';

import ButtonBase from '@material-ui/core/ButtonBase';


import Fab from '@material-ui/core/Fab';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Chip from '@material-ui/core/Chip';
//import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
//import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
//import Brightness3Icon from '@material-ui/icons/Brightness3';
//import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//import PictureAsPdfRoundedIcon from '@material-ui/icons/PictureAsPdfRounded';

import iTopOvernightOff from '../images/preview/Pay Per Night - Grey.svg';
import iTopBaysOff from '../images/preview/Parking - Grey.svg';
import iTopFacilitiesOff from '../images/preview/Facilities Only - Grey.svg';

import iTopOvernight from '../images/preview/Pay Per Night - Blue.svg';
import iTopBays from '../images/preview/Parking - Blue.svg';
import iTopFacilities from '../images/preview/Facilities Only - Blue.svg';


import iRecyclingOff from '../images/facilities/Recycling - Grey.svg';
import iBlackWaterOff from '../images/facilities/Black Water Disposal - Grey.svg';
import iElectricOff from '../images/facilities/Electric Hook Up - Grey.svg';
import iGreyWaterOff from '../images/facilities/Grey Water Disposal - Grey.svg';
import iLaundryOff from '../images/facilities/Laundry - Grey.svg';
import iOvernightOff from '../images/facilities/Overnight Parking - Grey.svg';
import iRubbishOff from '../images/facilities/Rubbish - Grey.svg';
import iShowerOff from '../images/facilities/Shower - Grey.svg';
import iToiletOff from '../images/facilities/Toilet - Grey.svg';
import iWaterOff from '../images/facilities/Water - Grey.svg';
import iWifiOff from '../images/facilities/Wifi - Grey.svg';

import iRecycling from '../images/facilities/Recycling - Coral.svg';
import iBlackWater from '../images/facilities/Black Water Disposal - Coral.svg';
import iElectric from '../images/facilities/Electric Hook Up - Coral.svg';
import iGreyWater from '../images/facilities/Grey Water Disposal - Coral.svg';
import iLaundry from '../images/facilities/Laundry - Coral.svg';
import iOvernight from '../images/facilities/Overnight Parking - Coral.svg';
import iRubbish from '../images/facilities/Rubbish - Coral.svg';
import iShower from '../images/facilities/Shower - Coral.svg';
import iToilet from '../images/facilities/Toilet - Coral.svg';
import iWater from '../images/facilities/Water - Coral.svg';
import iWifi from '../images/facilities/Wifi - Coral.svg';



import iCampra from '../images/campra/Campra Accredited - Green.svg';

import defaultSiteImage from '../images/Default-Image-Road.jpg';
import spinner from '../images/Driving-SVG.gif';


import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Container from '@material-ui/core/Container';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';


import Form from "react-bootstrap/Form";

import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';

import parse from 'html-react-parser';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import iLogo from "../images/logo.jpg";
import iQRLogo from "../images/qrcode_logo.svg";

import iCampraA from '../images/campra/Campra Accredited - Green.svg';
import iCampraX from '../images/campra/Campra Accredited - Grey.svg';


import QRCode from 'qrcode';
import { createCanvas, loadImage } from "node-canvas";

import '../fonts/Montserrat-Regular-normal.js';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import PromptTextarea from "../components/PromptTextarea";

import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import "./Prompt.css";

//import Papa from "papaparse";

//import DataGrid from "react-data-grid";

//import CSVReader from "react-csv-viewer";

//import CsvTable from "../components/CsvTable";

//import CreatableSelect from "react-select/creatable";


//import Calendar from 'react-calendar';
//import 'react-calendar/dist/Calendar.css';

//import CalendarPicker from 'react-native-calendar-picker';

//import DatePicker from "react-multi-date-picker";
//import { Calendar, DateObject } from "react-multi-date-picker"
////import "react-multi-date-picker/styles/colors/xxx.css"
//import "react-multi-date-picker/styles/colors/red.css"
//import colors from "react-multi-date-picker/plugins/colors"

//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import DateRangeIcon from '@material-ui/icons/DateRange';
//import Collapse from '@material-ui/core/Collapse';


//import Papa from 'papaparse';


//import DownloadCSV from '../components/DownloadCSV';




//import {LlamaParseReader} from "llamaindex";
//import 'dotenv/config'




export default function NTABS() {


  const history = useHistory();
  //const { userHasAuthenticated, isAuthenticated, isCampra, setShowSites} = useAppContext();


  const [fields, handleFieldChange] = useFormFields({
    email: "",
    reg: "",
  });
  const [tncs, setTncs] = useState(false);

  const { isAuthenticated, isCampra } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);
  const [switchingId, setSwitchingId] = useState(null);

  const [open, setOpen] = React.useState([]);
  const [paymentResult, setPaymentResult] = React.useState(false);
  const [sessionValues, setSessionValues] = React.useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [alertVals, handleAlertChange] = useFormFields({
    title: "",
    message: "",
  });



  const [currentSite, setCurrentSite] = useState(null);
  const [content, setContent] = useState("");
  const [siteOpen, setSiteOpen] = useState(false);
  //const [base64Image, setBase64Image] = useState("");
  //const [siteCode, setSiteCode] = useState("");
  //const [desc, setDesc] = useState("");
  //const [rules, setRules] = useState("");
  const [address, setAddress] = useState("");
  //const [accreditations, setAccreditations] = useState([]);


  const [sites, setSites] = useState([]);


  const [tabProcess, setTabProcess] = useState(0);





  const [statusText, setStatusText] = useState("");
  const [processText, setProcessText] = useState("");


  const [calendarVal, onCalendarVal] = useState([
    //new DateObject().setDay(5),
    ///new DateObject().setDay(12).color="red",
    //new DateObject().setDay(14).add(1, "month"),
    //new DateObject().setDay(23).add(1, "month"),

  ]);

  const [closedDatesChanged, setClosedDatesChanged] = React.useState([]);
  const [calendarExpanded, setCalendarExpanded] = React.useState([]);
  const handleExpandCalendarClick = (idx) => {
    const curr = calendarExpanded[idx];
    let newArr = new Array(calendarExpanded.length).fill(false);
    newArr[idx] = !curr;
    setCalendarExpanded(newArr);
  };


  const [forceUpdate, setForceUpdate] = React.useState(false);

  const [dateRange, setDateRange] = useState([
    //new DateObject()
  ])

  const [isUploading, setIsUploading] = useState(false);

  const [docTitle, setDocTitle] = useState("");
  const [docDesc, setDocDesc] = useState("");

  const [docFile, setDocFile] = useState(null);


  const [jobId, setJobId] = useState(null);
  const [ntabId, setNtabId] = useState(null);
  const [docId, setDocId] = useState(null);
  const [isParsing, setIsParsing] = useState(false);
  const [parsingStatus, setParsingStatus] = useState(null);
  const [isArtefacting, setIsArtefacting] = useState(false);
  const [artifactingStatus, setArtifactingStatus] = useState(null);
  const [parsedData, setParsedData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState("");
  //const [selectedModel, setSelectedModel] = useState('gpt-3.5-turbo');

  const [openaiData, setOpenaiData] = useState("");
  const [prompt, setPrompt] = useState("");

  const [files, setFiles] = useState([]);
  const [processingState, setProcessingState] = useState({ currentIndex: -1, isActive: false, userKey: 1 });
  const [isRunning, setIsRunning] = useState(false);
  const [resultsStatus, setResultsStatus] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);
  const [resultsData, setResultsData] = useState("");
  const startTimeRef = useRef(0);


  const [promptUserP1, setPromptUserP1] = useState("");
  const [promptSysP1, setPromptSysP1] = useState("");
  const [promptUserP2, setPromptUserP2] = useState("");
  const [promptSysP2, setPromptSysP2] = useState("");
  const [promptUserP3, setPromptUserP3] = useState("");
  const [promptSysP3, setPromptSysP3] = useState("");
  //const [sdoList, setSdoList] = useState("");
  const [validatorOptions, setValidatorOptions] = useState("");
  const [validatorResults, setValidatorResults] = useState("");
  const [enrichedNtab, setEnrichedNtab] = useState("");
  const [p1ResultsNtab, setP1ResultsNtab] = useState("");
  const [p2ResultsNtab, setP2ResultsNtab] = useState("");
  const [p3ResultsNtab, setP3ResultsNtab] = useState("");

  const [processId, setProcessId] = useState(Date.now());

  const [temperature, setTemperature] = useState(0.0);

  const [topP, setTopP] = useState(1.0);

  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);

  const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");



  const [fileUrl, setFileUrl] = useState(null);


  const [instanceKey, setInstanceKey] = useState(0); // for categoryinput component

  const [categories, setCategories] = useState([]);
  const [catCols, setCatCols] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [categoryData, setCategoryData] = React.useState([]);


  const [processIdOptions, setProcessIdOptions] = useState([]);

  const [selectedProcessIdOption, setSelectedProcessIdOption] = useState(null);

  const handleProcessIdChange = (newValue) => {
    setSelectedProcessIdOption(newValue);
    console.log(newValue);
  };

  const handleProcessIdCreate = (inputValue) => {
    // Filter input: only alphanumeric, _ and -
    const filtered = inputValue.replace(/[^A-Za-z0-9_-]/g, "");
    if (!filtered) return; // ignore if nothing valid
    const newOption = { value: filtered, label: filtered };
    //const newOption = { value: inputValue, label: inputValue };
    setProcessIdOptions((prev) => [...prev, newOption]);
    setSelectedProcessIdOption(newOption);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: "red", // selected item text color
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",  // text inside dropdown
      backgroundColor: state.isSelected ? "red" : "white", // highlight color
      "&:hover": {
        backgroundColor: "lightcoral",
      },
    }),
  };


  const metadataLookup = `
prompt_no,level,field,description\n
1,Table,table_id,Unique table identifier (e.g. NTAB_099).\n
1,Table,table_name,Table title or caption.\n
1,Table,ntab_type,"Table classification (e.g. income_statement, balance_sheet)."\n
1,Table,orientation,normal (periods in columns) or pivoted (periods in rows).\n
1,Table,axis_type,time (period-based) or attribute (non-time).\n
1,Table,ccy,"Default currency code (e.g. USD, EUR)."\n
1,Table,scale,"Default numeric scale (e.g. m, k, bn)."\n
1,Table,unit_type,"amount, per-share, percent, ratio, count, text"\n
1,Table,reference_date,Latest period end date (if time-based).\n
1,Table,scenario,reported (default) or forecast.\n
1,Table,section_id,"Logical section identifier (e.g. S001, S002)."\n
1,Column,col_id,Sequential column identifier (C001…).\n
1,Column,column_label,Header text or period label.,
1,Column,reference_date,Period end date (ISO format).\n
1,Column,period_months,Reporting duration (3 / 6 / 12) – optional for attribute tables.\n
1,Column,scenario,reported / forecast (defaults to table value).\n
1,Column,is_secondary_measure,Boolean; false by default (true if derived).\n
1,Row,row_id,Sequential row identifier (R001…).\n
1,Row,native_label,Original label (commas → semicolons).\n
1,Row,row_formatting,normal / bold / indented.\n
1,Row,indent_level,Structural depth (integer).\n
1,Row,section_id,Links row to its section.\n
1,Row,block_id,Optional logical block identifier (e.g. B001).\n
2,Row,block_id,"Logical grouping within a section (e.g. B001, B002)."\n
2,Row,role_of_row,"item, intermediate, total, header, note, component"\n
2,Row,sdo_code,Standardised line-item code (from lookup or SDO-UNMAP if no match found).\n
2,Row,standardised_label,Canonical standard label corresponding to the mapped SDO code.\n
2,Row,ccy,Verified or nullified currency code inherited from table-level metadata.\n
2,Row,scale,"Inherited or adjusted numeric scale (e.g. m, k, bn)."\n
2,Row,unit_type,"amount, per-share, percent, ratio, count, text"
`;








  const defaultCategories = [
    { key: 0, label: "No Fires." },
    { key: 1, label: "No awnings or camping furniture." },
    { key: 2, label: "Vehicles must be park within an allotted bay." },
    { key: 3, label: "Treat other guests with respect." },
    { key: 4, label: "Keep noise to a minimum. no music after 9pm." },
    { key: 5, label: "Leave no trace." }
  ];

  const models = [
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
    { value: 'gpt-4.1', label: 'GPT-4.1' },
    { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
    { value: 'gpt-4o', label: 'gpt-4o' }
  ];


  const categoriesStrxxx = `{
    "1": {"title": "Transaction Overview",
    "subsections":{
    "1.1":{"title": "Notices, Contacts and Administrative matters re this document"},
    "1.2":{"title": "Deal Summary"}
     }
    }
    
    }`;


  const categoriesStr = `{
"1": {"title": "Transaction Overview",
"subsections":{
"1.1":{"title": "Notices, Contacts and Administrative matters re this document"},
"1.2":{"title": "Deal Summary"},
"1.3":{"title": "Use of Proceeds"},
"1.4":{"title": "Sources & Uses"},
"1.5":{"title": "Capital Structure"}
}
},
"2": {"title": "Company Profile",
"subsections":{
"2.1":{"title": "Business Overview"},
"2.2":{"title": "Corporate History"},
"2.3":{"title": "Legal Structure"},
"2.4":{"title": "Ownership & Sponsors"}
}
},
"3": {"title": "Industry & Market",
"subsections":{
"3.1":{"title": "Industry Overview"},
"3.2":{"title": "Market Position"},
"3.3":{"title": "Competitive Landscape"}
}
},
"4": {"title": "Products & Services",
"subsections":{
"4.1":{"title": "Product/Service Portfolio"},
"4.2":{"title": "Customer Segments"},
"4.3":{"title": "Sales Channels & Distribution"}
}
},
"5": {"title": "Operations",
"subsections":{
"5.1":{"title": "Operational Footprint"},
"5.2":{"title": "Facilities & Assets"},
"5.3":{"title": "Supply Chain & Procurement"}
}
},
"6": {"title": "Management & Employees",
"subsections":{
"6.1":{"title": "Management Team"},
"6.2":{"title": "Organizational Structure"},
"6.3":{"title": "Human Resources"}
}
},
"7": {"title": "Financials",
"subsections":{
"7.1":{"title": "Historical Financials"},
"7.2":{"title": "Pro Forma Financials"},
"7.3":{"title": "Financial Projections"},
"7.4":{"title": "KPIs & Financial Metrics"}
}
},
"8": {"title": "Debt & Liabilities",
"subsections":{
"8.1":{"title": "Existing Debt"},
"8.2":{"title": "New Debt Terms"},
"8.3":{"title": "Debt Maturities"},
"8.4":{"title": "Covenants & Restrictions"}
}
},
"9": {"title": "Risk Factors",
"subsections":{
"9.1":{"title": "Operational Risks"},
"9.2":{"title": "Market Risks"},
"9.3":{"title": "Regulatory & Legal Risks"}
}
},
"10": {"title": "Legal & Compliance",
"subsections":{
"10.1":{"title": "Litigation"},
"10.2":{"title": "Regulatory Environment"},
"10.3":{"title": "Compliance & Permits"}
}
}
}`;




  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);



  const handleCategoryCheckboxChange = (e) => {
    const key = parseInt(e.target.value, 10);
    const checked = e.target.checked;

    setSelectedCategories((prev) =>
      checked ? [...prev, key] : prev.filter((k) => k !== key)
    );

  };


  const handleSelectDocument = (e) => {
    e.preventDefault();




    const fullCats = JSON.parse(categoriesStr);

    console.log(fullCats);
    setSelectedDoc(e.target.value)



    const doc = documents[e.target.value];

    const cats = JSON.parse(doc.content);

    let catOpts = [];
    //let colArr = [3];
    let idx = 0;
    let catidx = 0;
    for (const cat in fullCats) {
      //console.log(cat);
      const col = catidx < 3 ? 0 : catidx < 7 ? 1 : 2;
      catOpts.push({ key: idx, label: cat + " " + fullCats[cat].title, artefactIds: null, status: 0, col: col });
      idx++;
      catidx++;
      //console.log(catOpts);
      for (const subcat in fullCats[cat].subsections) {

        //console.log(subcat + " " + fullCats[cat].subsections[subcat].title);
        //console.log(cats[subcat]);
        const items = cats[subcat];
        catOpts.push({ key: idx, label: subcat + " " + fullCats[cat].subsections[subcat].title, artefactIds: items, status: items ? 1 : 9, col: col });
        idx++;
      }
    }
    console.log(catOpts);


    const colArr = Array.from({ length: 3 }, () => []);
    catOpts.forEach((catItem, index) => {
      console.log(catItem);
      colArr[catItem.col].push(catItem);
    });






    setCatCols(colArr);
    setCategories(catOpts);



    /*
    
       catOpts = [];
        console.log(cats);
         idx = 0;
        for (const cat in cats) {
          const items = cats[cat];
          catOpts.push({key: idx, label:cat, artefactIds: items});
          idx++;
          console.log(cat, items);
        };
        setCategories(catOpts);
    */





  };



  function handleAddCategoryClick() {
    categories.unshift(newCategory);
    categoryData.splice(0, categoryData.length)
    categories.map((cat, index) => {
      categoryData.push({ key: index, label: cat });
    })
    setInstanceKey(i => i + 1);
    setNewCategory("");
  }


  const newCategoryHandler = data => { setNewCategory(data.category) }

  /*
 React.useEffect(() => {
   categories=[];
   categoryData.map((data) => {
     categories.push(data.label)
   })
 }, [categoryData]);
*/

  const handleDeleteCategory = (categoryToDelete) => () => {
    setCategoryData((categories) => categories.filter((cat) => cat.key !== categoryToDelete.key));
  };

  /*
  React.useEffect(() => {
    setCategories(defaultCategories);
  }, []);
  */




  //const [jobId, setJobId] = useState('');
  const systemPromptAppend = 'only output markdown(md) and the page number within the json';





  useEffect(() => {

    onLoad();
  }, []);


  async function onLoad() {
    if (!isAuthenticated) { history.push("/"); return; }


  }

  ///////////////// UPLOADER //////////////////////////

  function createSite(site) {
    return API.post("aires", "/sites", {
      body: site
    });
  }
  async function buildSite(content) {
    try {
      console.log(content);
      //const result = await createSite({ content: content, image: "", itemStatus: 8}); // itemStatus -> DEfault = 8 (i.e. NON-Airestop site)
      return true;
    } catch (e) {
      onError(e);
      return false;
    }


  }


  var datafiles;
  var fileIndex = 0;

  const handleFile = e => {
    const content = e.target.result;








    /*
      try {
        const result = await uploadData({ aaa:111});
        readNextFile();
      } catch (e) {
        onError(e);
        setIsUploading(false);
      }
        */
  }
  /*
  function readNextFile() {
    fileIndex += 1;
    if (fileIndex >= datafiles.length) {
      setIsUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onloadend = handleFile;
    var f = datafiles[fileIndex];
    reader.readAsText(f);
  }
    */




  function readNextFile() {
    //console.log(datafiles);
    fileIndex += 1;
    if (fileIndex >= datafiles.length) {
      setIsUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onloadend = handleFile;
    var f = datafiles[fileIndex];
    reader.readAsText(f);
  }






  function uploadData(data) {
    //console.log(data);

    return API.post("spivolaaatsss", "/org/sitesaaaaaaaaaa", {
      body: data
    });

  }

  function parseDoc(body) {
    return API.post("findigai", "/parse", {
      body: body
    });
  }


  function validate(body) {
    return API.post("findigai", "/validation", {
      body: body
    });
  }


  function uploadDoc(body) {
    return API.post("findigai", "/documents/create", {
      body: body
    });
  }

  function getDocuments() {
    return API.get("findigai", "/documents");
  }
  function getOpenAI(body) {
    return API.post("findigai", "/openai", {
      body: body
    });
  }





  /*
    const pollParsingStatus = async () => {
      if (isParsing) {
        console.log("polling c");
        if (!jobId) return;
        try {
          const resultJob = await parseDoc({ type: "job", id: jobId });
          console.log(resultJob)
          const { status } = resultJob.data;
          setParsingStatus(status);
  
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            setIsParsing(false);
            if (status === "SUCCESS") {
  
              artifactise();
  
  
            } else {
              console.log("DOC PARSING FAILED: ", status)
            }
          }
        } catch (error) {
          console.error('Error checking parsing status:', error);
        }
      }
    };
  */
  /*
    const pollArtefactisationStatus = async () => {
      if (isArtefacting) {
        console.log("polling art a");
        if (!docId) return;
        try {
          const resultArt = await getOpenAI({type: 'artefactisation', docid: docId});
  
          console.log(resultJob)
  
          const { status } = resultJob.data;
          setParsingStatus(status);
  
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            setIsParsing(false);
            if (status === "SUCCESS") {
              const resultJobData = await parseDoc({type: "jobresult", id: jobId, output:"json"});
              console.log(resultJobData)
  
  
              //const {markdown} = resultJobData.data;
              const {structured} = resultJobData.data;
              const hier = buildHierarchy(structured);
  
              setParsedData(hier);
  
  
            }
          }
        } catch (error) {
          console.error('Error checking parsing status:', error);
        }
      }
    };
    */


  // Set up a polling mechanism that checks every 5 seconds until completed
  useEffect(() => {
    console.log("polling");
    let pollingInterval;

    if (isParsing) {
      console.log("polling b");
      pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isParsing, jobId]);

  /*
  useEffect(() => {
    console.log("polling art");
    let pollingInterval;

    if (isArtefacting) {
      console.log("polling art b");
      pollingInterval = setInterval(pollArtefactisationStatus, 5000); // Check every 5 seconds
    }
    try{
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch(e) {
      // do nowt
    }
    
  }, [isArtefacting, docId]);
*/



  async function handleFolderPick() {
    try {
      // Ask the user to pick a directory
      const dirHandle = await window.showDirectoryPicker();

      // Iterate over files in the directory
      for await (const [name, handle] of dirHandle.entries()) {
        if (handle.kind === "file" && name.toLowerCase().endsWith(".pdf")) {
          const file = await handle.getFile();
          console.log("PDF found:", file.name, file);

          // Example: read as ArrayBuffer
          const arrayBuffer = await file.arrayBuffer();
          console.log("Loaded", file.name, "size:", arrayBuffer.byteLength);
        }
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("User cancelled folder selection");
      } else {
        console.error("Error picking folder:", err);
      }
    }
  }


  useEffect(() => {
    let pollingInterval;
    if (isRunning) {
      pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
    }
    try {
      return () => {
        clearInterval(pollingInterval);
      } // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }
  }, [isRunning]); //

  const updateResultsStatus = () => {
    const timeDiff = (Date.now() - startTimeRef.current) / 1000;
    setResultsStatus(timeDiff)

  }



  useEffect(() => {
    //console.log("polling");
    let pollingInterval;
    if (isRunning && jobId) {
      pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isRunning, jobId]);



  useEffect(() => {
    //console.log("polling");
    let pollingInterval;
    if (isRunning && ntabId) {
      pollingInterval = setInterval(pollNTABStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isRunning, ntabId]);

  const pollNTABStatus = async () => {
    const file = files[processingState.currentIndex];
    const ntabType = ntabId.startsWith("ntab") ? ntabId.slice(4) : "";
    const body = { fileName: file.name, processId: processId, ntabType: ntabType };
    const result = await getNTABResult(body);
    console.log(body);
    console.log(result);
    if (result.status && result.data && result.data.itemStatus > 0) {
      const currentNtabId = ntabId;
      setNtabId(null);
      if (currentNtabId == "ntabP1") {
        setProcessText("P2 querying");
        setP1ResultsNtab(result.data.results);
        runPxQuery("ntabP2");
      } else if (currentNtabId == "ntabP2") {
        setProcessText("P3 querying");
        setP2ResultsNtab(result.data.results);
        runPxQuery("ntabP3");
      } else if (currentNtabId == "ntabP3") {
        setProcessText("Validating");
        setP3ResultsNtab(result.data.results);
        setEnrichedNtab(result.data.results);
        const valResult = await validate({ type: "TEST-NTAB", fileName: file.name, processId });
        console.log(valResult);
        setValidationResults(file);
        setIsRunning(false);
        //validateNTAB(result.data.results, true);
      }
    } else if (result.error && result.findigCode && result.findigCode == 3) {
      // Do nowt ie record not yet created
    } else {
      setIsRunning(false);
      alert("NTAB Extraction Failed - see logs")
    }
  }

  async function setValidationResults(file) {
    const body = { fileName: file.name, processId: processId, ntabType: "VAL" };
    const result = await getNTABResult(body);
    let errorHtml = "<b>unable to retrieve errors</b>";
    if (result.data.results) {
      const errors = result.data.results;
       errorHtml = "<b>no errors</b>";
        if (errors.length > 0) {
            let currentNtab = "";
            errors.forEach((error, index) => {
                if (currentNtab == "") {
                    errorHtml = "<h5><b>" + error.ntabId + "</b></h5>";
                    currentNtab = error.ntabId;
                } else if (currentNtab != error.ntabId) {
                    errorHtml += "<br/><br/><h6><b>" + error.ntabId + "</b></h6>";
                    currentNtab = error.ntabId;
                }
                errorHtml += "&nbsp;&nbsp;&nbsp;<b>" + error.type + "</b><br/>";
                Object.entries(error.details).forEach(([key, detail]) => {
                    if (key == "fixes") {
                        errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fixes:<br/>";
                        Object.entries(detail).forEach(([key2, detail2]) => {
                            errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key2 + ": " + detail2 + "<br/>";
                        });
                    } else {
                        errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key + ": " + detail + "<br/>";
                    }
                });
            });
        }
      }
      setValidatorResults(errorHtml);
    }



  const pollParsingStatus = async () => {

    if (isRunning) {
      if (isCancelling) {
        setIsRunning(false);
        setResultsData("Cancelled ok!");
        setIsCancelling(false);
        // should request a cancellation to llamaparse here
      } else {
        try {
          if (!jobId) return;
          const resultJob = await parseDoc({ type: "job", id: jobId });
          const { status } = resultJob.data;
          console.log(status, status !== "PENDING", status === "SUCCESS")
          //resultsData += " " + status
          //setResultsData(resultsData);
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            if (status === "SUCCESS") {
              setJobId(null);
              setResultsData("parsing completed ok!");
              setProcessText("P1 querying");
              //const p1Result = await runP1Query();
              runPxQuery("ntabP1");
              /*if (p1Result.status) {
                //setIsRunning(false);
                //setResultsData(clues.result);
                console.log(p1Result.result);
                setP1ResultsNtab(p1Result.result);
                setProcessText("P2 querying");
                const p2Result = await runP2Query();
                if (p2Result.status) {
                  console.log(p2Result.result);
                  setP2ResultsNtab(p2Result.result);
                  setProcessText("P3 querying");
                  const p3Result = await runP3Query();
                  if (p3Result.status) {
                    console.log(p3Result.result);
                    setProcessText("Validating");
                    setP3ResultsNtab(p3Result.result);
                    validateNTAB(p3Result.result, true);
                  } else {
                    //await processNextFile();
                    //setIsRunning(false);
                    //setResultsData("extractQuery failed: " + extract.result);
                    console.log("extractQuery failed at P3: " + p3Result.result);
                  }

                } else {
                  //await processNextFile();
                  //setIsRunning(false);
                  //setResultsData("extractQuery failed: " + extract.result);
                  console.log("extractQuery failed at P2: " + p2Result.result);
                }

              } else {
                //await processNextFile();
                //setIsRunning(false);
                //setResultsData("cluesQuery failed: " + clues.result);
                console.log("cluesQuery failed at P1: " + p1Result.result);
              }*/

            } else {
              //await processNextFile();
              //setIsRunning(false);
              //setResultsData("parsing failed: " + status);
              console.log("DOC PARSING FAILED: ", status)
            };

          }
        } catch (error) {
          await processNextFile();
          //setIsRunning(false);
          //setResultsData("parsing failed: " + error.message);
          console.error('Error checking parsing status:', error);
        }
      }
    }

  };

  /*
  const pollParsingStatus = async () => {
    if (isRunning) {
      if (isCancelling) {
        setIsRunning(false);
        setResultsData("Cancelled ok!");
        setIsCancelling(false);
        // should request a cancellation to llamaparse here
      } else {
        try {
          if (!jobId) return;
          const resultJob = await parseDoc({ type: "job", id: jobId });
          const { status } = resultJob.data;
          console.log(status, status !== "PENDING", status === "SUCCESS")
          //resultsData += " " + status
          //setResultsData(resultsData);
          if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
            if (status === "SUCCESS") {
              setJobId(null);
              setResultsData("parsing completed ok!");
              setProcessText("P1 querying");
              const p1Result = await runP1Query();
              if (p1Result.status) {
                //setIsRunning(false);
                //setResultsData(clues.result);
                console.log(p1Result.result);
                setP1ResultsNtab(p1Result.result);
                setProcessText("P2 querying");
                const p2Result = await runP2Query();
                if (p2Result.status) {
                  console.log(p2Result.result);
                  setP2ResultsNtab(p2Result.result);
                  setProcessText("P3 querying");
                  const p3Result = await runP3Query();
                  if (p3Result.status) {
                    console.log(p3Result.result);
                    setProcessText("Validating");
                    setP3ResultsNtab(p3Result.result);
                    validateNTAB(p3Result.result, true);
                  } else {
                    //await processNextFile();
                    //setIsRunning(false);
                    //setResultsData("extractQuery failed: " + extract.result);
                    console.log("extractQuery failed at P3: " + p3Result.result);
                  }

                } else {
                  //await processNextFile();
                  //setIsRunning(false);
                  //setResultsData("extractQuery failed: " + extract.result);
                  console.log("extractQuery failed at P2: " + p2Result.result);
                }

              } else {
                //await processNextFile();
                //setIsRunning(false);
                //setResultsData("cluesQuery failed: " + clues.result);
                console.log("cluesQuery failed at P1: " + p1Result.result);
              }

            } else {
              //await processNextFile();
              //setIsRunning(false);
              //setResultsData("parsing failed: " + status);
              console.log("DOC PARSING FAILED: ", status)
            };

          }
        } catch (error) {
          await processNextFile();
          //setIsRunning(false);
          //setResultsData("parsing failed: " + error.message);
          console.error('Error checking parsing status:', error);
        }
      }
    }

  };
  */

  async function validateNTAB(dirtyNtab = null, addToValidatorCSVView = false) {
    try {


      /*
      if (dirtyNtab == null) {
        const result = await getTuningRecords("CampbellSoup01.pdf-1760451974181");
        if (result.status) {
          console.log(result.data);
          dirtyNtab = result.data.results;
        } else {
          console.log(result);
        }
      }
        */


      /*
      const match = dirtyNtab.match(/table-begin:([\s\S]*?)table-end:/);
      let tabStr = "";
      if (match) {
        tabStr = match[1].trim();
        console.log(tabStr);
      } else {
        console.log("No table found");
      }
      */


      let ntabs = [];
      let table = null;
      let beginExists = false;
      let endExists = false;
      let rowsStart = 0;
      const errors = [];


      console.log(dirtyNtab);

      const lines = dirtyNtab.split(/\r?\n/); // handles both \n and \r\n
      lines.forEach((line, index) => {
        //console.log(`Line ${index + 1}:`, line);
        if (line.includes("table-begin:")) {
          beginExists = true;
        } else if (line.includes("table-end:")) {
          endExists = true;
          if (table != null) {
            ntabs.push(table);
          }
        } else {
          if (line.includes("table_id=NTAB_")) {
            //console.log("table metadata");
            if (table != null) {
              ntabs.push(table);
            }
            [, table] = getMetadataFromPipedString(null, line);
            table["dataColumnList"] = [];
            table["rowList"] = [];
            table["blocks"] = [];
          }
          if (line.includes("col_metadata")) {
            const cleanLine = line.trim().replace(/^,/, "").replace(/\|$/, ""); // trims spaces and removes leading comma and trailing pipe
            const items = cleanLine.split(",");
            const [id, metadata] = getMetadataFromPipedString("col_id", items[1])
            table.dataColumnList.push(metadata);
            if (!table["dataColumns"]) table["dataColumns"] = {}; // initialise if not already
            table.dataColumns[id] = metadata;
          } else if (line.includes("row_id")) {
            const headers = line.split(",");


            table["columnHeaderList"] = headers;


            if (!table["columnHeaders"]) table["columnHeaders"] = {};
            headers.forEach((header, index) => {
              let metadata = table.dataColumns[header];
              if (metadata) {
                metadata["col_index"] = index;
              } else {
                metadata = { "col_index": index };
              }
              table.columnHeaders[header] = metadata;
            });
            table["rowsStartIndex"] = index;
          } else if (table["rowsStartIndex"]) {
            if (table.rowsStartIndex > 0 && index > table.rowsStartIndex) {
              const cols = line.split(",");
              table.rowList.push(cols);
              if (!table["rows"]) table["rows"] = {};
              if (!table.rows["byId"]) table.rows["byId"] = {};
              if (!table.rows["byNativeLabel"]) table.rows["byNativeLabel"] = {};
              if (!table.rows["byStandardisedLabel"]) table.rows["byStandardisedLabel"] = {};
              const metadata = { row_index: index - rowsStart - 1 };
              const data = {};

              table.columnHeaderList.forEach((header, index) => {
                let isDataCol = false;
                for (let i = 0; i < table.dataColumnList.length; i++) {
                  if (table.dataColumnList[i].col_id == header) {
                    isDataCol = true;
                    if (data[header]) { // test for error ie if data[header] already exists
                      errors.push({ ntabId: table.table_id, type: "duplicate_data_header", details: { header: header } });
                    } else {
                      data[header] = {};
                      data[header]["index"] = i;
                      data[header]["value"] = cols[index];
                    }

                  }
                }
                //console.log(header, cols[index]);
                //console.log(cols[index]);
                if (!isDataCol) {
                  metadata[header] = cols[index];
                }
              });

              table.rows.byId[metadata.row_id] = {};
              table.rows.byId[metadata.row_id]["metadata"] = metadata;
              table.rows.byId[metadata.row_id]["data"] = data;
              if (metadata.block_id && metadata.block_id.trim() != "") {
                if (!table.blocks[metadata.block_id]) table.blocks[metadata.block_id] = {};
                if (!table.blocks[metadata.block_id]["rows"]) table.blocks[metadata.block_id]["rows"] = [];
                if (!table.blocks[metadata.block_id]["cols"]) table.blocks[metadata.block_id]["cols"] = {};
                table.blocks[metadata.block_id].rows.push(metadata.row_id);
              } else {
                errors.push({ ntabId: table.table_id, type: "row_has_no_block_assigned", details: { row_id: metadata.row_id } });
              }
            }
          }
        }
      });

      console.log(ntabs);

      //metadataLookup

      const metadataObj = Papa.parse(metadataLookup, {
        header: true,  // use first line as keys
        skipEmptyLines: true
      });
      //console.log(metadataObj.data);

      const tableMetadata = metadataObj.data.filter(obj => obj.level === "Table");
      const colMetadata = metadataObj.data.filter(obj => obj.level === "Column");
      const rowMetadata = metadataObj.data.filter(obj => obj.level === "Row");

      //console.log(tableMetadata);
      //console.log(colMetadata);
      //console.log(rowMetadata);

      //console.log(ntabs);
      if (ntabs.length > 1) {
        errors.push({ ntabId: "n/a", type: "multiple_tables", details: { tableCount: ntabs.length } });
      }
      let csv = "";
      const roles = [];
      ntabs.forEach((ntab, index) => {
        //console.log(ntab);
        tableMetadata.forEach((metaItem, index) => {
          const fieldName = metaItem.field;
          if (ntab[fieldName]) {
            if (ntab[fieldName] != "") {
              //console.log(fieldName, " Found with value");
            } else {
              //console.log(fieldName, " Found BUT no value!");
              errors.push({ ntabId: ntab.table_id, type: "missing_table_metadata", details: { [fieldName]: "Found But with no value" } });
            }
          } else {
            //console.log(metaItem.field, " NOT Found!");
            errors.push({ ntabId: ntab.table_id, type: "missing_table_metadata", details: { [fieldName]: "Not Found" } });
          }
        });
        csv = "native_label"
        const colCount = ntab.columnHeaderList.length;
        ntab.dataColumnList.forEach((dataCol, index) => {
          const colid = dataCol.col_id;
          colMetadata.forEach((metaItem, index) => {
            const fieldName = metaItem.field;
            if (dataCol[fieldName]) {
              if (dataCol[fieldName] != "") {
                //console.log(fieldName, " Found with value");
              } else {
                //console.log(fieldName, " Found BUT no value!");
                errors.push({ ntabId: ntab.table_id, type: "missing_column_metadata", details: { col_id: colid, [fieldName]: "Found But with no value" } });
              }
            } else {
              //console.log(metaItem.field, " NOT Found!");
              errors.push({ ntabId: ntab.table_id, type: "missing_column_metadata", details: { col_id: colid, [fieldName]: "Not Found" } });
            }
          });
          csv += "," + colid;
        });
        ntab.rowList.forEach((row, index) => {
          const rowid = row[ntab.columnHeaders["row_id"].col_index];
          if (row.length != colCount) {
            errors.push({ ntabId: ntab.table_id, type: "col_count_mismatch", details: { offset: colCount - row.length } });
          }
          rowMetadata.forEach((metaItem, index) => {
            const fieldName = metaItem.field;
            if (ntab.rows.byId[rowid].metadata[fieldName]) {
              const val = ntab.rows.byId[rowid].metadata[fieldName];
              if (val != "") {
                //console.log(fieldName, " Found with value");
                if (fieldName == "role_of_row") {
                  const roles = metaItem.description.split(",").map(item => item.trim());;
                  if (!roles.includes(val)) {
                    errors.push({ ntabId: ntab.table_id, type: "invalid_role_of_row", details: { row_id: rowid, value: val } });
                  }
                } else if (fieldName == "block_id") {
                  if (!/^B\d+$/.test(val)) {
                    errors.push({ ntabId: ntab.table_id, type: "invalid_block_id", details: { row_id: rowid, value: val } });
                  }
                } else if (fieldName == "unit_type") {
                  const unitTypes = metaItem.description.split(",").map(item => item.trim());;
                  if (!unitTypes.includes(val)) {
                    errors.push({ ntabId: ntab.table_id, type: "invalid_unit_type", details: { row_id: rowid, value: val } });
                  } else {
                    // for each data val test if conforms
                    Object.keys(ntab.rows.byId[rowid].data).forEach(key => {
                      const dataVal = ntab.rows.byId[rowid].data[key].value;
                      //console.log(dataVal);
                      if (dataVal.trim() === "") {
                        errors.push({ ntabId: ntab.table_id, type: "blank_data_value", details: { row_id: rowid, col_id: key, unitType: val, value: dataVal } });
                      } else if (val == "text") {

                      } else { // all numeric
                        if (isNaN(dataVal)) {
                          errors.push({ ntabId: ntab.table_id, type: "invalid_data_value", details: { row_id: rowid, col_id: key, unitType: val, value: dataVal } });
                        } else if (val == "percent") {
                          const num = Number(dataVal);
                          if (num < 0 || num > 100) {
                            errors.push({ ntabId: ntab.table_id, type: "invalid_percentage_value", details: { row_id: rowid, col_id: key, unitType: val, value: dataVal } });
                          }
                        }
                      }
                    });
                  }
                }
              } else {
                //console.log(fieldName, " Found BUT no value!");
                errors.push({ ntabId: ntab.table_id, type: "missing_row_metadata", details: { row_id: rowid, [fieldName]: "Found But with no value" } });
              }
            } else {
              //console.log(metaItem.field, " NOT Found!");
              errors.push({ ntabId: ntab.table_id, type: "missing_row_metadata", details: { row_id: rowid, [fieldName]: "Not Found" } });
            }
          });
          if (ntab.rows.byId[rowid].metadata["standardised_label"] && ntab.rows.byId[rowid].metadata["standardised_label"] == "Unmapped") {
            errors.push({ ntabId: ntab.table_id, type: "unmapped_label", details: { row_id: rowid, sdo_code: ntab.rows.byId[rowid].metadata["sdo_code"] } });
          }
          csv += "\n" + row[ntab.columnHeaders["native_label"].col_index];
          ntab.dataColumnList.forEach((dataCol, index) => {
            csv += "," + row[ntab.columnHeaders[dataCol.col_id].col_index];
          });
        });
        Object.keys(ntab.blocks).forEach(block_id => {
          ntab.dataColumnList.forEach((dataCol, index) => {
            const col_id = dataCol.col_id;
            if (!ntab.blocks[block_id].cols[col_id]) ntab.blocks[block_id].cols[col_id] = {};
            let total = 0;
            //console.log(ntab.blocks[block_id]);
            ntab.blocks[block_id].rows.forEach((row_id, index) => {
              const row = ntab.rows.byId[row_id];
              console.log();
              console.log(row_id);

              if (row.metadata.role_of_row && row.metadata.role_of_row == "item") {
                total += Number(row.data[col_id].value);
                //console.log(row.metadata.role_of_row,row.data[col_id].value, total);
              } else if (row.metadata.role_of_row && row.metadata.role_of_row == "total") {
                if (!ntab.blocks[block_id].cols[col_id]["total"]) {
                  ntab.blocks[block_id].cols[col_id]["total"] = Number(row.data[col_id].value);
                } else {
                  errors.push({ ntabId: ntab.table_id, type: ">1_total_for_block", details: { block_id: block_id } });
                }
              }
            });
            ntab.blocks[block_id].cols[col_id]["sum"] = total;
          });
        });
        Object.keys(ntab.blocks).forEach(block_id => {
          Object.entries(ntab.blocks[block_id].cols).forEach(([key, col]) => {
            if (!col.total) {
              const fixes = {};
              ntab.blocks[block_id].rows.forEach((row_id, index) => {
                const row = ntab.rows.byId[row_id];
                if (Number(row.data[key].value) == col.sum) {
                  fixes[row_id] = "change_role_to_total_from_" + row.metadata.role_of_row;
                }
              });
              errors.push({ ntabId: ntab.table_id, type: "no_total_for_block", details: { block_id: block_id, col_id: key, fixes: Object.keys(fixes).length === 0 ? { "---": "none available" } : fixes } });
            } else {
              const diff = col.total - col.sum;
              if (diff != 0) {
                const fixes = {};
                if (Math.abs(col.total > Math.abs(col.sum))) {
                  ntab.blocks[block_id].rows.forEach((row_id, index) => {
                    const row = ntab.rows.byId[row_id];
                    if (!row.metadata.role_of_row || row.metadata.role_of_row != "item") {
                      if (Number(row.data[key].value) == diff) {
                        fixes[row_id] = "change_role_to_item_from_" + row.metadata.role_of_row;
                      }
                    }
                  });
                } else { // Math.abs(col.total < Math.abs(col.sum)
                  ntab.blocks[block_id].rows.forEach((row_id, index) => {
                    const row = ntab.rows.byId[row_id];
                    if (row.metadata.role_of_row || row.metadata.role_of_row == "item") {
                      if (Number(row.data[key].value) == (diff * -1)) {
                        fixes[row_id] = "change_role_from_item";
                      }
                    }
                  });
                }
                errors.push({ ntabId: ntab.table_id, type: "block_column_sum_difference", details: { block_id: block_id, col_id: key, difference: diff, fixes: Object.keys(fixes).length === 0 ? { "---": "none available" } : fixes } });
              }
            }
          });
        });


      });
      console.log(ntabs);
      console.log(errors);

      let errorHtml = "<b>no errors</b>";
      if (errors.length > 0) {
        let currentNtab = "";
        errors.forEach((error, index) => {
          if (currentNtab == "") {
            errorHtml = "<h5><b>" + error.ntabId + "</b></h5>";
            currentNtab = error.ntabId;
          } else if (currentNtab != error.ntabId) {
            errorHtml += "<br/><br/><h6><b>" + error.ntabId + "</b></h6>";
            currentNtab = error.ntabId;
          }
          errorHtml += "&nbsp;&nbsp;&nbsp;<b>" + error.type + "</b><br/>";
          Object.entries(error.details).forEach(([key, detail]) => {
            if (key == "fixes") {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fixes:<br/>";
              Object.entries(detail).forEach(([key2, detail2]) => {
                errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key2 + ": " + detail2 + "<br/>";
              });
            } else {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key + ": " + detail + "<br/>";
            }
          });
        });
      }
      if (!endExists) {
        errorHtml = "missing '<b>table-end:</b>' label";
      }



      if (addToValidatorCSVView) {
        setEnrichedNtab(dirtyNtab);
      }
      setValidatorResults(errorHtml);





    } catch (e) {
      console.log("ERROR: ", e.message

      );

    }



    setIsRunning(false);








  }

  function getMetadataFromPipedString(id = null, line) {
    console.log(line, id);
    const metadata = line.split("|");
    const obj = {};
    let idVal = null;
    metadata.forEach((pair, index) => {
      if (pair.includes("=")) {
        const [key, value] = pair.split("=").map(s => s.trim());
        obj[key] = value;
        if (id && id == key) {
          idVal = value;
        }
      }
    });
    return [idVal, obj];
  }

  async function onComplete() {
    const result = await getTuningRecords(processId);
    if (result.status) {
      console.log(result.data);
      downloadZip(result.data);
    }
  }

  async function runExtractionQuery(clues) {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "tableextract", clues: clues, processId: processingState.processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }


  async function runPxQuery(type) {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const body = { type: type, processId: processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() };
      console.log(body);
      const result = await getOpenAI(body);
      console.log(result);
      resultsStr = result.body;
      setNtabId(type);
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }

  /*
  async function runP1Query() {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "ntabP1", processId: processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }

  async function runP2Query() {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "ntabP2", processId: processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }

  async function runP3Query() {
    let resultsStr = "";
    try {
      const file = files[processingState.currentIndex];
      const result = await getOpenAI({ type: "ntabP3", processId: processId, fileName: file.name, keyId: processingState.userKey, config: getConfigObj() });
      console.log(result);
      resultsStr = result.body;
      return { status: true, result: resultsStr };
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }
    */

  function downloadZip(csvFiles) {
    const zip = new JSZip();
    csvFiles.forEach((file) => {
      if (file.name && file.ntab) {
        const fn = file.name.substring(0, file.name.lastIndexOf(".")) || file.name;
        zip.file("dirty_" + fn + ".csv", file.ntab);
      }
    });
    // Generate the zip and trigger download
    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, "dirty_ntabs.zip"); // triggers a download
    });

  }

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    if (!isAuthenticated) { history.push("/"); return; }
    loadConfig();
  }

  const loadConfig = async () => {
    const result = await getConfig();
    let cf = {};
    for (let i = 0; i < result.data.length; i++) {
      const val = result.data[i];
      const skArr = val.sk.split("|");
      const step = skArr[skArr.length - 1];
      cf[step.toLowerCase()] = val.content;
    }
    setPromptUserP1(cf.ntabs.options.promptUserP1);
    setPromptSysP1(cf.ntabs.options.promptSysP1);
    setPromptUserP2(cf.ntabs.options.promptUserP2);
    setPromptSysP2(cf.ntabs.options.promptSysP2);
    setPromptUserP3(cf.ntabs.options.promptUserP3);
    setPromptSysP3(cf.ntabs.options.promptSysP3);
    //setSdoList(cf.ntabs.options.sdos);
    setValidatorOptions(cf.ntabs.options.validator);
    setTemperature(cf.ntabs.options.temperature);
    setTopP(cf.ntabs.options.topP);
    setPresencePenalty(cf.ntabs.options.presencePenalty);
    setFrequencyPenalty(cf.ntabs.options.frequencyPenalty);
    setSelectedModel(cf.ntabs.options.model);
  }

  function getConfig() {
    return API.get("findigai", "/config");
  }

  function getTuningRecords(processId) {
    return API.get("findigai", `/tuning/${processId}`);
  }

  function getNTABResult(body) {
    return API.post("findigai", "/ntabs", {
      body: body
    });
  }

  const handleFolderSelect = async (event) => {
    const files = Array.from(event.target.files);
    setProcessingState(prev => ({ ...prev, currentIndex: -1, isActive: false, fileCount: files.length }));
    setFiles(files);
    setResultsStatus('0');
    setStatusText(String(files.length) + " table files to process");
  }

  async function processNextFile(processId = null) {
    const newKey = processingState.userKey == 1 ? 2 : 1;
    const idx = processingState.currentIndex + 1;
    if (idx >= processingState.fileCount) {
      setStatusText("Processing completed");
      setIsRunning(false);
      await onComplete();
    } else {
      if (processId) {
        setProcessingState(prev => ({ ...prev, currentIndex: idx, processId: processId, isActive: true }));
      } else {
        setProcessingState(prev => ({ ...prev, currentIndex: idx, userKey: newKey }));
      }
      const file = files[idx];
      setFileDetails(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1]; // Get base64 data
        console.log(base64String);
        setProcessText("Parsing");
        uploadDoc({ type: "parse-for-ntabs", processId: processId, doc: base64String, fileName: file.name })
          .then(resultParse => {
            console.log("Got data:", resultParse);
            const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
            const { id, status } = data;
            console.log(data);
            setJobId(id);
          })
          .catch(err => {
            console.error('Error processing file:', err);
          });
      };
    }
  }

  const handleProcessFilesClick = async (event) => {
    //validateNTAB();
    const timestamp = Date.now();
    setProcessId(timestamp);
    setIsRunning(true);
    startTimeRef.current = timestamp;
    setResultsData('Parsing...')
    await processNextFile(timestamp);
  }


  const handleValidatorOnlyClick = async (event) => {
    setIsRunning(true);
    const file = files[processingState.currentIndex];
    const valResult = await validate({ type: "TEST-NTAB", fileName: file.name, processId });
    console.log(valResult);
    setValidationResults(file)
    setIsRunning(false);
    //validateNTAB(enrichedNtab);
  }

  function uploadDoc(body) {
    return API.post("findigai", "/parse", {
      body: body
    });
  }


  const handleUploadClick = async (event) => {
    event.preventDefault();
    if (isUploading) {
      return;
    }
    console.log(event.target.files.length);
    if (event.target.files.length == 0) {
      return;
    }

    const file = event.target.files[0];
    const result = await getDocuments();
    let isDuplicate = false;
    let version = 0;
    for (const doc of result.data) {
      if (doc.name == file.name) {
        isDuplicate = true;
        if (doc.version && doc.version > version) {
          version = doc.version;
        }
      }
    }
    version++;
    setFileDetails({ file: event.target.files[0], version: version, isDuplicate: isDuplicate });
    if (!isDuplicate) {
      uploadParseDoc();
    }
  }

  const continueFileUpload = (event) => {
    event.preventDefault();
    uploadParseDoc();
  }


  const uploadParseDoc = async () => {
    //console.log("uploadParseDoc");
    setIsUploading(true);
    fileIndex = -1;
    const file = fileDetails.file;
    const version = fileDetails.version;
    setFileDetails(null);
    //console.log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      const base64String = reader.result.split(',')[1]; // Get base64 data
      try {
        const resultParse = await parseDoc({ doc: base64String, fileName: file.name, version: version, promptAppend: systemPromptAppend });
        console.log(resultParse)
        const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
        setDocId(resultParse.docId);
        const { id, status } = data;
        setParsingStatus(status);
        setJobId(id);
        setIsParsing(true);
        setEnrichedNtab("");
        setP1ResultsNtab("");
        setP2ResultsNtab("");
        setP3ResultsNtab("");
        setFileUrl(resultParse.location);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    };
    setIsUploading(false);
  }


  function buildHierarchy(parsedJson) {
    const hierarchy = [];
    const stack = [{ level: 0, children: hierarchy }]; // Root container

    parsedJson.forEach((item) => {
      const match = item.text.match(/^(#+)\s*(.*)/); // Detect Markdown-style headers

      if (match) {
        const level = match[1].length; // Number of '#' determines heading level
        const title = match[2];

        const newNode = { title, level, children: [] };

        // Find the correct parent in the stack
        while (stack.length && stack[stack.length - 1].level >= level) {
          stack.pop();
        }

        stack[stack.length - 1].children.push(newNode);
        stack.push(newNode);
      }
    });

    return hierarchy;
  }


  function renderLoader() {
    return (
      <div id="splash" style={{ paddingTop: 100, zIndex: 999 }}>

        <center id="splash">
          <img src={spinner} height="30px" width="auto" />
          {/*}<Typography style={{padding: '4px'}} variant="caption">{label}</Typography>*/}
        </center>
      </div>


    );

  }
  const getJob = async (e) => {
    e.preventDefault();
    if (jobId != "") {
      //const resultJobData = await parseDoc({type: "jobresult", id: jobId, output:"json"});
      const resultJobData = await parseDoc({ type: "reformat", id: jobId, output: "json" });
      //console.log(resultJobData)
      setParsedData(resultJobData.data);


    }


  }



  const runArtefactisation = async (e) => {
    e.preventDefault();
    artifactise();
  }

  const artifactise = async () => {
    setIsArtefacting(true);
    setArtifactingStatus("Artifacting started...");
    let artStatus = 0;
    let message;
    while (artStatus < 2) {
      const result = await getOpenAI({ type: 'artefactisation', docid: docId });
      message = result;
      if (result.statusCode == 500) { // ERROR
        // delete all new records for the docid
        artStatus = 9;
      } else if (result.statusCode == 200) {
        if (result.documentStatus) {
          artStatus = result.documentStatus;
          const status = "Completed: page " + String(result.page) + " of " + String(result.pages);
          console.log(status);
          setArtifactingStatus(status);
        } else {
          // delete all new records for the docid
          result["extrainfo"] = "ERROR: no documentStatus in result with status 200";
          message = result;
          artStatus = 9;
        }
      }
    }
    if (artStatus == 2) {
      message = "Artefacting completed successfully!";
    } else if (artStatus != 9) {
      message = `"ERROR: Terminated with incorrect artStatus: ${artStatus}`;
    }
    console.log(message);
    setArtifactingStatus(message);
    setIsArtefacting(false);
  }


  const getDocs = async (e) => {
    e.preventDefault();
    const result = await getDocuments();
    setDocuments(result.data);
    //console.log(result);
  }

  const doQuery = async (e) => {
    e.preventDefault();
    if (isUploading) {
      return;
    }
    setIsUploading(true);
    //const result = await getDocuments();
    //setDocuments(result.data);


    if (selectedCategories && selectedCategories.length < 1) {
      alert("Please select at least one category.");
      return;
    }


    //console.log(selectedKeys);

    let allNumbers = [];
    for (const cat in selectedCategories) {
      console.log(selectedCategories[cat]);
      console.log(categories[selectedCategories[cat]]);

      const ids = categories[selectedCategories[cat]].artefactIds;


      // Merge & deduplicate
      allNumbers = [...allNumbers, ...ids];


    }
    const uniqueIds = [...new Set(allNumbers)];
    console.log(uniqueIds);
    const uniqueSortedNumbers = [...new Set(allNumbers)].sort((a, b) => a - b);
    console.log(uniqueSortedNumbers);

    //"Identify any risks with this company?"

    const body = { cats: uniqueSortedNumbers, prompt: prompt, model: selectedModel };
    //const result = await getOpenAI(body);
    try {
      const result = await getOpenAI({ cats: uniqueSortedNumbers, prompt: prompt, model: selectedModel });
      console.log(body);
      //console.log(result);
      setOpenaiData(result.data);
    } catch (err) {
      console.error("OpenAI Error:", err?.response?.data || err.message || err);
    }

    setIsUploading(false);



  }

  /*
    function updateConfig(body) {
      setConfig(prev => ({
        ...prev,
        [body.type]: body.values,
      }));
      return API.patch("findigai", "/config", {
        body: body
      });
    }
      */

  function updateConfig(body) {
    //console.log(body);
    //console.log(config);
    //console.log(config[body.type]);
    //setConfig(prev => ({
    //    ...prev,
    //    [body.type]: body.values,
    //}));
    return API.patch("findigai", "/config", {
      body: body
    });
  }


  const openFileDialog = () => {
    const input = document.getElementById("upload-data");
    input.value = ""; // Reset the input to allow re-selection of the same file
    //input.click();
  };

  /*
    const saveConfig = async () => {
      const body = getConfigObj();
      await updateConfig(body);
    }
*/

  const saveConfig = async () => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    const body = getConfigObj();
    await updateConfig(body);
    setIsRunning(false);
    // resetResults();
  }

  function getConfigObj() {
    return { type: "ntabs", values: { options: { promptSysP1: promptSysP1, promptUserP1: promptUserP1, promptSysP2: promptSysP2, promptUserP2: promptUserP2, promptSysP3: promptSysP3, promptUserP3: promptUserP3, /*sdos: sdoList,*/ model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty } } };
  }


  const handleTopPChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTopP(newValue);
  }
  const handleTemperatureChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTemperature(newValue);
  }
  const handlePresencePenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setPresencePenalty(newValue);
  }
  const handleFrequencyPenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setFrequencyPenalty(newValue);
  }


  function handleTabChange(event, value) {
    setTabProcess(value);
  };
  /*
    function CsvDataGrid({ csvText }) {
      const { data } = Papa.parse(csvText, { header: true });
      const columns = Object.keys(data[0] || {}).map(key => ({ key, name: key }));
      //console.log(data);
          //console.log(columns);
      return <DataGrid columns={columns} rows={data} />;
    }
  */

  function renderLander() {
    return (
      <>
        <Box sx={{ width: "100%" }}>
          <h2 style={{ margin: 0 }}>NTAB Test PipeLine</h2>
          <Box p={2} >
            <label htmlFor="upload-data">
              <input
                disabled={isRunning}
                accept=".PDF"

                id="upload-data"
                name="upload-data"
                multiple="false"
                type="file"
                onChange={handleFolderSelect}
                hidden
              />
              <Button disabled={isRunning} onClick={openFileDialog} color="primary" variant="contained" component="span" startIcon={<QueueIcon />}>Select table files (.pdf)</Button>

            </label>
          </Box>


          <>
            <Box p={2} >
              <h6> {statusText}{Number(resultsStatus) > 0 ? " - " + String(Number(resultsStatus).toFixed(2)) + " seconds." : ""}</h6>
            </Box>
            {/*}
              <Box p={2} >
                <span style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
                  <h3 style={{ margin: 0 }}>Process ID:</h3>
                  <h6 style={{ margin: 0 }}> (only use letters, numbers, underscores and dash)</h6>
                </span>
                <h3>
                  <CreatableSelect
                    disabled={isRunning}
                    isClearable
                    onChange={handleProcessIdChange}
                    onCreateOption={handleProcessIdCreate}
                    onInputChange={(input) => input.replace(/[^A-Za-z0-9_-]/g, "")}
                    styles={customStyles}
                    options={processIdOptions}
                    value={selectedProcessIdOption}
                    placeholder="Select or type to add..."
                    formatCreateLabel={(inputValue) => `➕ Add "${inputValue}"`}
                  />
                </h3>
              </Box>
              */}
            <Box p={2} mb={4}>
              <Button disabled={files.length == 0 || !processId || isRunning} onClick={handleProcessFilesClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run pipeline</Button>
            </Box>


            <Box mt={1} sx={{ width: "100%" }}>
              <Paper style={{ backgroundColor: "#f2f2ff" }}>

                <Box p={2}>
                  <Tabs
                    value={tabProcess}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="false"
                  >
                    <Tab label={
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">NTAB-P1</Typography>
                      </Box>
                    } sx={{ '&.Mui-selected': { outline: 'none', } }} />
                    <Tab label={
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">NTAB-P2</Typography>
                      </Box>
                    } sx={{ '&.Mui-selected': { outline: 'none', } }} />
                    <Tab label={
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">NTAB-P3</Typography>
                      </Box>
                    } sx={{ '&.Mui-selected': { outline: 'none', } }} />
                    <Tab label={
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">Validation</Typography>
                      </Box>
                    } sx={{ '&.Mui-selected': { outline: 'none', } }} />

                  </Tabs>
                  <Paper style={{ backgroundColor: "#efe" }}>
                    <Box p={1}>



                      {tabProcess == 0 ?
                        <>

                          <Paper style={{ backgroundColor: "#ffe" }}>
                            <Box p={1} mb={4}>
                              <Box pv={2} pl={0.5}>
                                <h6>P1 results</h6>
                              </Box>


                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={p1ResultsNtab}
                                onChange={(e) => setP1ResultsNtab(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />
                            </Box>
                          </Paper>







                          <Box pv={2} pl={0.5}>
                            <h6>System prompt (P1)</h6>
                          </Box>
                          <Paper style={{ backgroundColor: "#fff" }}>
                            <Box p={1}>
                              <HighlightWithinTextarea
                                disabled={isRunning}
                                placeholder="<empty>"
                                value={promptSysP1 ?? ""}
                                highlight={[
                                  { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                  { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                  { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                ]}
                                onChange={(text) => setPromptSysP1(text)}
                              />
                            </Box>
                          </Paper>
                          {/*}

                          <TextareaAutosize
                            disabled={isRunning}
                            minRows={1}
                            placeholder="<empty>"
                            value={promptSysP1}
                            onChange={(e) => setPromptSysP1(e.target.value)}
                            style={{
                              width: '100%',
                              padding: '12px',
                              fontSize: '16px',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                              resize: 'vertical',
                            }}
                          />
                          */}

                          <Box pt={3} pb={0} pl={0.5} >
                            <h6>User prompt (P1)</h6>
                          </Box>

                          <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                            &nbsp;&nbsp;NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{tab-md}}}"}</i></span><br />
                          </Typography>
                          <Paper style={{ backgroundColor: "#fff" }}>
                            <Box p={1}>
                              <HighlightWithinTextarea
                                disabled={isRunning}
                                placeholder="<empty>"
                                value={promptUserP1 ?? ""}
                                highlight={[
                                  { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                  { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                  { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                ]}
                                onChange={(text) => setPromptUserP1(text)}
                              />
                            </Box>
                          </Paper>
                          {/*}
                          <TextareaAutosize
                            disabled={isRunning}
                            minRows={1}
                            placeholder="<empty>"
                            value={promptUserP1}
                            onChange={(e) => setPromptUserP1(e.target.value)}
                            style={{
                              width: '100%',
                              padding: '12px',
                              fontSize: '16px',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                              resize: 'vertical',
                            }}
                          />*/}
                        </>
                        : tabProcess == 1 ?
                          <>


                            <Paper style={{ backgroundColor: "#ffe" }}>
                              <Box p={1} mb={4}>
                                <Box pv={2} pl={0.5}>
                                  <h6>P2 results</h6>
                                </Box>


                                <TextareaAutosize
                                  disabled={true}
                                  minRows={1}
                                  value={p2ResultsNtab}
                                  onChange={(e) => setP2ResultsNtab(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}

                                />

                              </Box>
                            </Paper>

                            <Box pv={2} pl={0.5}>
                              <h6>System prompt (P2)</h6>
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptSysP2 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptSysP2(text)}
                                />
                              </Box>
                            </Paper>
                            {/*
                            <TextareaAutosize
                              disabled={isRunning}
                              minRows={1}
                              placeholder="<empty>"
                              value={promptSysP2}
                              onChange={(e) => setPromptSysP2(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                              }}
                            />*/}
                            <Box pt={3} pb={0} pl={0.5} >
                              <h6>User prompt (P2)</h6>
                            </Box>

                            <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                              &nbsp;&nbsp;NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{p1-tab}}}"}</i></span> and  <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{sdo-list}}}"}</i></span><br />
                            </Typography>


                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptUserP2 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptUserP2(text)}
                                />
                              </Box>
                            </Paper>
                            {/*}                           
                            <TextareaAutosize
                              disabled={isRunning}
                              minRows={1}
                              placeholder="<empty>"
                              value={promptUserP2}
                              onChange={(e) => setPromptUserP2(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                              }}
                            />

                            <Box pv={2} pl={0.5}>
                              <h6>SDOs (in CSV table format)</h6>
                            </Box>



                            <TextareaAutosize
                              disabled={isRunning}
                              minRows={1}
                              placeholder="<empty>"
                              value={sdoList}
                              onChange={(e) => setSdoList(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                              }}
                            />
*/}
                          </>
                          : tabProcess == 2 ?
                            <>


                              <Paper style={{ backgroundColor: "#ffe" }}>
                                <Box p={1} mb={4}>
                                  <Box pv={2} pl={0.5}>
                                    <h6>P3 results (Enriched NTAB) </h6>
                                  </Box>


                                  <TextareaAutosize
                                    disabled={isRunning}
                                    minRows={1}
                                    placeholder="<empty>"
                                    value={p3ResultsNtab}
                                    onChange={(e) => setP3ResultsNtab(e.target.value)}
                                    style={{
                                      width: '100%',
                                      padding: '12px',
                                      fontSize: '16px',
                                      borderRadius: '8px',
                                      border: '1px solid #ccc',
                                      resize: 'vertical',
                                    }}
                                  />
                                </Box>
                              </Paper>

                              <Box pv={2} pl={0.5}>
                                <h6>System prompt (P3)</h6>
                              </Box>

                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptSysP3 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptSysP3(text)}
                                  />
                                </Box>
                              </Paper>
                              {/*}
                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={promptSysP3}
                                onChange={(e) => setPromptSysP3(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />*/}
                              <Box pt={3} pb={0} pl={0.5} >
                                <h6>User prompt (P3)</h6>
                              </Box>

                              <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                                &nbsp;&nbsp;NB: Must include <span style={{ color: "#922821", fontWeight: "bold" }}><i>{"{{{p2-tab}}}"}</i></span><br />
                              </Typography>

                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptUserP3 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptUserP3(text)}
                                  />
                                </Box>
                              </Paper>

                              {/*}
                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={promptUserP3}
                                onChange={(e) => setPromptUserP3(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />*/}
                            </>
                            :
                            <>
                              <Box p={2} mb={1}>
                                <Button disabled={enrichedNtab == "" || isRunning} onClick={handleValidatorOnlyClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run Validator ONLY</Button>
                              </Box>

                              <Box pv={2} pl={0.5}>
                                <h6>Enriched NTAB (as CSV)</h6>
                              </Box>


                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={enrichedNtab}
                                onChange={(e) => setEnrichedNtab(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />

                              <Box pv={2} pl={0.5}>
                                <h6>Results</h6>
                              </Box>

                              <Box sx={{ p: 2, border: "1px solid #ccc" }}
                                dangerouslySetInnerHTML={{ __html: validatorResults }}>
                              </Box>


                            </>
                      }



                    </Box>
                  </Paper>
                  {tabProcess < 3 &&
                    <>
                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              disabled={isRunning}
                              value={temperature}
                              onChange={handleTemperatureChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Temperature</h6>
                        </Box>
                      </Box>

                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              disabled={isRunning}
                              value={topP}
                              onChange={handleTopPChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Top P</h6>
                        </Box>
                      </Box>

                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              disabled={isRunning}
                              value={presencePenalty}
                              onChange={handlePresencePenaltyChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Presence penalty</h6>
                        </Box>
                      </Box>
                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                        <Box width={26} pt={3} pb={0} pl={0.5} >
                          <Paper>
                            <TextField
                              type="number"
                              disabled={isRunning}
                              value={frequencyPenalty}
                              onChange={handleFrequencyPenaltyChange}
                              disableUnderline
                              inputProps={{
                                disableUnderline: true,
                                min: 0,
                                max: 1,
                              }}
                            />
                          </Paper>
                        </Box>
                        <Box pt={3} pb={0} pl={0.5} >
                          <h6> Frequency penalty</h6>
                        </Box>
                      </Box>

                      <Box my={2} ml={0.5}>
                        <select
                          id="model"
                          disabled={isRunning}
                          value={selectedModel}
                          onChange={(e) => setSelectedModel(e.target.value)}
                        >
                          {models.map((model) => (
                            <option key={model.value} value={model.value}>
                              {model.label}
                            </option>
                          ))}
                        </select>

                      </Box>


                      <Box pt={3} pb={0} pl={0.5} >
                        <p style={{ fontSize: "0.75rem" }}><i>Note: To save the prompts and params without running the query use the SAVE button. The prompts and params will be automatically saved if you run the query.</i></p>
                      </Box>
                      <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>
                        <Box sx={{ flexGrow: 1 }} ></Box>
                        <Box my={2} mr={3}>
                          <Button
                            variant="contained" component="span"
                            disabled={isRunning}
                            onClick={(e) => {
                              e.preventDefault();
                              saveConfig();
                            }} color="primary">
                            Save
                          </Button>
                        </Box>
                      </Box>




                    </>
                  }


                </Box>
              </Paper>
            </Box>



          </>


          {/*}
      
          <Box p={2} >
            <label htmlFor="upload-data">


<input type="file" webkitdirectory="true" onChange={handleFolderSelect} />
          </label>
          </Box>


<Box p={2} >
          <button onClick={handleFolderPick}>Choose Folder</button>
</Box>
         

          <Box p={2} >
            <Button onClick={getJob} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Get result for</Button>
            <input
              type="text"
              placeholder="Job id"
              value={jobId}
              onChange={(e) => setJobId(e.target.value)}
            />
          </Box>

          <Box p={2} >
            {isParsing && <p>Parsing in progress...</p>}
            {parsingStatus && <p>Parsing Status: {parsingStatus}</p>}
            {isArtefacting && <p>Artifacting in progress...</p>}
            {artifactingStatus && <p>Parsing Status: {artifactingStatus}</p>}
           

          </Box>


          <Box p={2} >
            <Button onClick={uploadOmarArtifacts} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>upload omar artifacts</Button>
            <input
              type="text"
              placeholder="doc title"
              value={docTitle}
              onChange={(e) => setDocTitle(e.target.value)}
            />
            <input
              type="text"
              placeholder="doc desc"
              value={docDesc}
              onChange={(e) => setDocDesc(e.target.value)}
            />
          </Box>



          <Box p={2} >
            <Button onClick={runArtefactisation} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Do Artefactisation</Button>

          </Box>





          <Box my={2} mr={3}>
            <Button onClick={getDocs} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>Get List of Docs</Button>
          </Box>
          {documents.length > 0 &&
            <div>
              <label htmlFor="documents">Choose a document:</label>
              <select
                id="document"
                value={selectedDoc}
                onChange={handleSelectDocument}
              >
                <option value="" disabled hidden>-- Select doc --</option>
                {documents.map((opt, index) => (
                  <option key={opt.itemId} value={index}>
                    {opt.name + (opt.version ? " (version " + opt.version + ")" : "")}
                  </option>
                ))}
              </select>
            </div>
          }

            */}



        </Box>


        {/*}
        <br />
        {catCols && catCols.length > 0 &&
          <Paper variant="outlined">
            <Box p={1}><h3>Select Categories</h3></Box>

            <Box p={1} display="flex" gap={2} flexDirection="row">

              {catCols.map((cats) => (
                <Box flex={1} p={2} flexDirection="column">
                  {cats.map((cat) => (
                    <label key={cat.key} style={{ display: "block", marginBottom: "4px", color: cat.status == 9 ? 'gray' : 'black' }}>
                      {cat.status > 0 &&
                        <input
                          type="checkbox"
                          value={cat.key}
                          disabled={cat.status == 9}
                          checked={selectedCategories.includes(cat.key)}
                          onChange={handleCategoryCheckboxChange}
                        />
                      }
                      {cat.status == 0 ? <><b>{cat.label}</b></> : <>&nbsp;{cat.label}</>}
                    </label>
                  ))}
                </Box>
              ))}
            </Box>
          </Paper>
        }
        <br />

        {catCols && catCols.length > 0 &&
          <>
            <TextareaAutosize
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              minRows={3}
              maxRows={10}
              style={{
                width: '100%',
                padding: 8,
                fontSize: 16,
                borderRadius: 4,
                border: '1px solid #ccc',
              }}
              placeholder="Type prompt..."
            />

            <Box my={2} >
              <select
                id="model"
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
              >
                {models.map((model) => (
                  <option key={model.value} value={model.value}>
                    {model.label}
                  </option>
                ))}
              </select>
            </Box>


            <Box my={2} >
              <Button onClick={doQuery} color="primary" variant="contained" component="span" startIcon={<CloudUploadIcon />}>do Query</Button>
            </Box>

          </>
        }


        <Box my={3}>


          {openaiData &&
            <Paper>
              <Box p={2} >
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{openaiData}</pre>
              </Box>
            </Paper>
          }


          {parsedData &&
            <Paper>
              <Box p={2} >
                <pre>{JSON.stringify(parsedData, null, 2)}</pre>

              </Box>
            </Paper>
          }
        </Box>

        */}
      </>
    )
  }


  return (

    <div className="Sites">
      {isLoading ? renderLoader() : renderLander()}
      <LoadingModal open={isRunning} message={processingState.currentIndex > -1 ? `Processing file: ${processingState.currentIndex + 1} of ${processingState.fileCount} (${files[processingState.currentIndex].name})` : "Processing..."} message2={processText + "..."} message3={Number(resultsStatus).toFixed(2) + " seconds"} />
      <Dialog
        open={fileDetails && fileDetails.isDuplicate}
        fullWidth={false}
        maxWidth={'md'}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
          Document Upload
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            A file with the same name (<b>{fileDetails && fileDetails.file.name}</b>) has already been uploaded. Click UPLOAD continue with the upload creating a new version (<b>v.{fileDetails && fileDetails.version}</b>) of the document.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { setFileDetails(null) }} color="primary">
            Cancel
          </Button>
          <Button onClick={continueFileUpload} color="secondary">
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}